import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/place.svg'


const _withScopeId = n => (_pushScopeId("data-v-1316e486"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "book-info" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = { class: "info-detail" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-title" }, "탑승일", -1 /* HOISTED */))
const _hoisted_5 = { class: "info-content board-date" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "board-chip" }, "탑승", -1 /* HOISTED */))
const _hoisted_7 = { class: "info-detail line-info" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-title" }, "탑승노선", -1 /* HOISTED */))
const _hoisted_9 = { class: "info-content" }
const _hoisted_10 = { class: "line-route-name" }
const _hoisted_11 = { class: "info-detail departure-info" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-title" }, "승차", -1 /* HOISTED */))
const _hoisted_13 = { class: "bus-stop-name" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "지도에서 위치 보기"
}, null, -1 /* HOISTED */))
const _hoisted_16 = { class: "info-detail arrival-info" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-title" }, "하차", -1 /* HOISTED */))
const _hoisted_18 = { class: "bus-stop-name" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "지도에서 위치 보기"
}, null, -1 /* HOISTED */))
const _hoisted_21 = {
  key: 1,
  class: "info-detail"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-title" }, "탑승위치", -1 /* HOISTED */))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "지도에서 위치 보기"
}, null, -1 /* HOISTED */))
const _hoisted_24 = { class: "info-detail" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-title" }, "차량정보", -1 /* HOISTED */))
const _hoisted_26 = { class: "info-content" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 2,
  class: "info-detail"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-title" }, "예약일시", -1 /* HOISTED */))
const _hoisted_30 = { class: "info-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", null, _toDisplayString($setup.dayjs($props.boardInfo.realGetOnDateTime).format("YYYY-MM-DD(dd)")), 1 /* TEXT */),
          _hoisted_6
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createVNode($setup["LineTypeChip"], {
            lineTypeCode: $props.boardInfo.lineTypeCode,
            lineTypeName: $props.boardInfo.lineTypeName,
            isSmallSize: true
          }, null, 8 /* PROPS */, ["lineTypeCode", "lineTypeName"]),
          _createElementVNode("p", _hoisted_10, _toDisplayString($setup.useGetLineRouteName(
                $props.boardInfo.lineTypeCode,
                $props.boardInfo.lineRouteName,
                $props.boardInfo.lineRouteNo
              )) + " " + _toDisplayString($props.boardInfo.firstStopTime), 1 /* TEXT */)
        ])
      ]),
      ($setup.isBookingLine)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", {
                class: "info-content",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (
              $setup.emitOnClickBusStopLocation($props.boardInfo.expectedGetOnBusStopUid)
            ))
              }, [
                _createElementVNode("p", _hoisted_13, _toDisplayString($props.boardInfo.expectedGetOnBusStopName), 1 /* TEXT */),
                ($props.boardInfo.expectedGetOnTime)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(`(${$props.boardInfo.expectedGetOnTime})`), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                _hoisted_15
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", {
                class: "info-content",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (
              $setup.emitOnClickBusStopLocation($props.boardInfo.expectedGetOffBusStopUid)
            ))
              }, [
                _createElementVNode("p", _hoisted_18, _toDisplayString($props.boardInfo.expectedGetOffBusStopName), 1 /* TEXT */),
                ($props.boardInfo.expectedGetOffTime)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(`(${$props.boardInfo.expectedGetOffTime})`), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                _hoisted_20
              ])
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", {
              class: "info-content",
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.emitOnClickBusStopLocation($props.boardInfo.realGetOnBusStopUid)))
            }, [
              _createElementVNode("span", null, _toDisplayString($props.boardInfo.realGetOnBusStopName ?? "-"), 1 /* TEXT */),
              _hoisted_23
            ])
          ])),
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("span", null, _toDisplayString($props.boardInfo.carNo ?? "-"), 1 /* TEXT */),
          ($props.boardInfo.vendorName)
            ? (_openBlock(), _createElementBlock("span", _hoisted_27, "(" + _toDisplayString($props.boardInfo.vendorName) + ")", 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      ($setup.isBookingLine)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("span", null, _toDisplayString($props.boardInfo.bookDateTime), 1 /* TEXT */)
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}